import api from "./api";

export const getStatus = async () => {
    try {
        const response = await api.get("/status_");
        return response.data;
    } catch (error) {
        return null;
    }
};